<template>
  <q-card class="customer-card" :style="bgColor">
    <q-item>
      <q-item-section avatar>
        <q-avatar>
          <img src="https://cdn.quasar.dev/img/avatar2.jpg" />
        </q-avatar>
      </q-item-section>
      <q-item-section>
        <q-item-label>{{ customer.id }}</q-item-label>
      </q-item-section>
      <q-item-section>
        <q-item-label>{{ customer.name }}</q-item-label>
      </q-item-section>
    </q-item>
  </q-card>
</template>

<script>
import { QCard, QItem, QAvatar, QItemSection } from "quasar";

const components = { QCard, QItem, QAvatar, QItemSection };

export default {
  name: "CustomerCard",
  props: ["customer", "selected"],
  components: {
    ...components,
  },
  data() {
    return {};
  },
  computed:{
    bgColor(){
      return this.selected ? "background: #acb3b9 !important;" : "background: white !important; color: black;"
    },
  },
  methods: {
  }
};
</script>

<style scoped>

.customer-card{
    height: 80px;
    margin: 0 10px;
    cursor: pointer;
}

</style>
